<template>
  <main class="airdrop-page">
    <section class="main-page-1">
      <div class="container-main">
        <div class="main-page-1__text_block">
          <div class="main-page-1__heading">
            <span class="heading-one visible" ref="heading1">
              Private round
            </span>
            <span
              class="heading-two"
              :class="{ 'anim-fade': animations.anim1 === true }"
              >
              Price 0.10 USDT
            </span>
          </div>
          <div
            class="main-page-1__subtext"
            :class="{ 'anim-fade': animations.anim1 === true }"
            style="animation-delay: 0.4s"
          >
            <span>Per 1 TKZ</span>
          </div>
          <div
            class="main-page-1__text text-1-1"
            :class="{ 'anim-fade': animations.anim1 === true }"
            style="animation-delay: 0.6s"
          >
            <span v-html="t('welcome.head_1')"></span>
          </div>
          <div
            class="main-page-1__text text-1-2"
            :class="{ 'anim-fade': animations.anim1 === true }"
            style="animation-delay: 0.8s"
          >
            <span v-html="t('welcome.head_2')"></span>
          </div>
        </div>
        <div
          class="main-page-1__coin_1 coin-1"
          :class="{ 'anim-fade': animations.anim1 === true }"
          style="animation-delay: 0.2s"
        >
          <div class="parallax">
            <div class="dop-block" data-depth="-0.5">
              <img src="img/main/coin-1.png" alt="" />
            </div>
          </div>
        </div>
        <div
          class="main-page-1__coin_2 coin-1"
          :class="{ 'anim-fade': animations.anim1 === true }"
          style="animation-delay: 0.4s"
        >
          <div class="parallax">
            <div class="dop-block" data-depth="0.3">
              <img src="img/main/coin-2.png" alt="" />
            </div>
          </div>
        </div>
        <div
          class="main-page-1__coin_3 coin-1"
          :class="{ 'anim-fade': animations.anim1 === true }"
          style="animation-delay: 0.6s"
        >
          <div class="parallax">
            <div class="dop-block" data-depth="-0.1">
              <img src="img/main/coin-3.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="main-page-1__bg_1">
        <img class="first-bg-1" src="img/main/galaxy-1.png" alt="" /><img
          class="first-bg-2"
          src="img/main/galaxy-1.png"
          alt=""
        />
      </div>
      <div class="main-page-1__phone">
        <img
          src="img/main/phone-1.png"
          :class="{ 'anim-fade': animations.anim1 === true }"
          alt=""
        />
      </div>
      <div class="main-page-1__line_1">
        <img
          src="img/main/line-1.svg"
          :class="{ 'anim-glow': animations.anim1 === true }"
          alt=""
        />
      </div>
      <div class="main-page-1__line_2">
        <img
          src="img/main/line-2.svg"
          :class="{ 'anim-glow': animations.anim1 === true }"
          style="animation-delay: 0.4s"
          alt=""
        />
      </div>
    </section>
    <section class="main-page-2">
      <div class="container-main">
        <div class="main-page-2__heading vis_on_scroll" ref="heading2">
          <span v-html="t('welcome.heading_2')"></span>
        </div>
        <div class="main-page-2__items">
          <div
            class="main-page-2__item fromTop"
            :class="{ 'anim-fade': animations.anim2 === true }"
            style="animation-delay: 0.2s"
          >
            <div class="main-page-2__item_image first-image">
              <img class="one" src="img/main/item-1.png" alt="" />
            </div>
            <div class="main-page-2__item_text_block">
              <div class="main-page-2__item_text_1">
                <span v-html="t('airdrop.page-2.text_1')"></span>
              </div>
              <div class="main-page-2__item_text_2">
                <span v-html="t('airdrop.page-2.text_2')"></span>
              </div>
              <div class="main-page-2__item_text_3">
                <span v-html="t('airdrop.page-2.text_3')"></span>
              </div>
              <div class="main-page-2__item_text_4">
                <span v-html="t('airdrop.page-2.text_4')"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-5" id="tokenomic">
      <div class="container">
        <div class="section-5__heading vis_on_scroll" ref="heading9">
          <span>Tokenomics</span>
        </div>
        <div class="section-5__text_block">
          <div class="section-5__left_text_block">
            <div
              class="section-5__left_text_1 section-5-text-item"
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 0.1s"
            >
              <img src="img/welcome/section-5/tkz.png" alt="" /><span>TKZ</span>
            </div>
            <div
              class="section-5__left_text_2 section-5-text-item"
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 0.2s"
            >
              <span v-html="t('landing.tokenomics.desc_1')"></span>
            </div>
            <div
              class="section-5__left_text_3 section-5-text-item"
              :class="{ 'anim-fade': animations.anim9 === true }"
              id="whitepaper"
              style="animation-delay: 0.3s"
            >
              <span>9,800,000,000</span><span>total supply</span>
            </div>
            <div
              class="section-5__left_text_3 section-5-text-item"
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 0.4s"
            >
              <span>$5,850,000</span
              ><span>Total Usd raised in the seed round</span>
            </div>
            <div
              class="section-5__left_text_3 section-5-text-item"
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 0.5s"
            >
              <span>$ 1</span><span>listing price</span>
            </div>
            <div
              class="section-5__download_text section-5-text-item" 
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 0.6s"
            >
              <span v-html="t('landing.tokenomics.desc_2')"></span>
            </div>
            <a
              class="section-5__download_btn section-5-text-item"
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 0.7s"
              target="_blank"
              href="presentations/WP Tokenza.pdf"
              ><img src="img/welcome/section-5/doc-icon.svg" alt="" /><span
                >White Paper</span
              ></a
            >
          </div>
          <div class="section-5__right_text_block">
            <div
              class="section-5__right_text_1 section-5-text-item"
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 0.8s"
            >
              <span>Tron <br />blockchain <br />(TRc20)</span>
            </div>
            <div
              class="section-5__right_text_2 section-5-text-item"
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 0.9s"
            >
              <span v-html="t('landing.tokenomics.desc_3')"></span>
            </div>
          </div>
          <div class="section-5__arr_left">
            <img
              src="img/welcome/section-5/arr-left.svg"
              alt=""
              :class="{ 'anim-glow': animations.anim9 === true }"
              style="animation-delay: 0.6s"
            />
          </div>
          <div class="section-5__arr_right">
            <img
              src="img/welcome/section-5/arr-left.svg"
              alt=""
              :class="{ 'anim-glow': animations.anim9 === true }"
              style="animation-delay: 1.4s"
            />
          </div>
          <div class="section-5__galaxy">
            <img
              class="first-bg-1"
              src="img/welcome/section-5/galaxy.png"
              alt=""
            /><img
              class="first-bg-2"
              src="img/welcome/section-5/galaxy.png"
              alt=""
            />
          </div>
          <div class="section-5__coin">
            <img
              src="img/welcome/section-5/coin.png"
              alt=""
              :class="{ 'anim-fade': animations.anim9 === true }"
              style="animation-delay: 1.6s"
            />
          </div>
        </div>
      </div>
    </section>
    
    <section class="main-page-4-1">
      <div class="container-main">
        <div class="main-page-4-1__text_block">
          <div class="main-page-4-1__text_1 vis_on_scroll" ref="heading10">
            <span v-html="t('airdrop.roadmap.title')"></span>
          </div>

          <div class="main-page-4-1__text">
            <div class="main-page-4-1__text_2">
              <div class="main-page-4-1__text_2_number">
                <span>2022</span>
              </div>
              <div class="main-page-4-1__text_2_info">
                <span v-html="t('airdrop.roadmap.item_1')"></span>
              </div>
            </div>
            <div class="main-page-4-1__text_2">
              <div class="main-page-4-1__text_2_number">
                <span>2023</span>
              </div>
              <div class="main-page-4-1__text_2_info">
                <span v-html="t('airdrop.roadmap.item_2')"></span>
              </div>
            </div>
            <div class="main-page-4-1__text_2">
              <div class="main-page-4-1__text_2_number">
                <span>2024</span>
              </div>
              <div class="main-page-4-1__text_2_info">
                <span v-html="t('airdrop.roadmap.item_3')"></span>
              </div>
            </div>
            <div class="main-page-4-1__text_2">
              <div class="main-page-4-1__text_2_number">
                <span>2024</span>
              </div>
              <div class="main-page-4-1__text_2_info">
                <span v-html="t('airdrop.roadmap.item_4')"></span>
              </div>
            </div>
          </div>
        </div>
        
        <div
          class="main-page-4-1__coin_4 coin-2"
          :class="{ 'anim-fade': animations.anim10 === true }"
        >
          <div class="parallax">
            <div class="dop-block" data-depth="0.1">
              <img src="img/main/coin-4.png" alt="" />
            </div>
          </div>
        </div>
        <div
          class="main-page-4-1__coin_5 coin-2"
          :class="{ 'anim-fade': animations.anim10 === true }"
          style="animation-delay: 0.2s"
        >
          <div class="parallax">
            <div class="dop-block" data-depth="-0.1">
              <img src="img/main/coin-5.png" alt="" />
            </div>
          </div>
        </div>
        <!-- <div class="main-page-4-1__line_5">
          <img
            src="img/main/line-5.svg"
            alt=""
            :class="{ 'anim-glow': animations.anim10 === true }"
            style="animation-delay: 0.6s"
          />
        </div> -->
      </div>
      <div class="main-page-4-1__bg_3">
        <img class="first-bg-1" src="img/main/galaxy-3.png" alt="" /><img
          class="first-bg-2"
          src="img/main/galaxy-3.png"
          alt=""
        />
      </div>
    </section>

    <section class="main-page-3">
      <div class="container-main">
        <div class="main-page-3__text_block">
          <div class="main-page-3__text_1 vis_on_scroll" ref="heading3">
            <span>Tokenza Wallet</span>
          </div>
          <div
            class="main-page-3__text_2"
            :class="{ 'anim-fade': animations.anim3 === true }"
          >
            <!-- <span v-html="t('welcome.oktober')"></span> -->
          </div>
          <div
            class="main-page-3__text_3"
            :class="{ 'anim-fade': animations.anim3 === true }"
            style="animation-delay: 0.4s"
          >
            <span v-html="t('welcome.wallet_desc')"></span>
          </div>
        </div>
        <div
          class="main-page-3__phone_2 vis_on_scroll"
          :class="{ visible: animations.anim3 === true }"
        >
          <img src="img/main/phone-2.png" alt="" />
        </div>
        <div class="main-page-3__line_3">
          <img
            src="img/main/line-3.svg"
            :class="{ 'anim-fade': animations.anim3 === true }"
            style="animation-delay: 0.1s"
            alt=""
          />
        </div>
        <div class="main-page-3__line_4">
          <img
            src="img/main/line-4.svg"
            :class="{ 'anim-fade': animations.anim3 === true }"
            style="animation-delay: 0.3s"
            alt=""
          />
        </div>
      </div>
      <div class="main-page-3__bg_2">
        <img class="first-bg-1" src="img/main/galaxy-2.png" alt="" /><img
          class="first-bg-2"
          src="img/main/galaxy-2.png"
          alt=""
        />
      </div>
    </section>
    <section class="main-page-4">
      <div class="container-main">
        <div class="main-page-4__text_block">
          <div class="main-page-4__text_1 vis_on_scroll" ref="heading4">
            <span>Tokenza Swap</span>
          </div>
          <div
            class="main-page-4__text_2"
            :class="{ 'anim-fade': animations.anim4 === true }"
          >
            <span>Multi-chain permissionless trading</span>
          </div>
          <div
            class="main-page-4__text_3"
            :class="{ 'anim-fade': animations.anim4 === true }"
            style="animation-delay: 0.4s"
          >
            <span v-html="t('welcome.smart_desc')"></span>
          </div>
          <div
            class="main-page-4__text_3"
            :class="{ 'anim-fade': animations.anim4 === true }"
            style="animation-delay: 0.4s"
          >
            <span v-html="t('welcome.tron_desc')"></span>
          </div>
        </div>
        <div
          class="main-page-4__coin_4 coin-2"
          :class="{ 'anim-fade': animations.anim4 === true }"
        >
          <div class="parallax">
            <div class="dop-block" data-depth="0.1">
              <img src="img/main/coin-4.png" alt="" />
            </div>
          </div>
        </div>
        <div
          class="main-page-4__coin_5 coin-2"
          :class="{ 'anim-fade': animations.anim4 === true }"
          style="animation-delay: 0.2s"
        >
          <div class="parallax">
            <div class="dop-block" data-depth="-0.1">
              <img src="img/main/coin-5.png" alt="" />
            </div>
          </div>
        </div>
        <div class="main-page-4__line_5">
          <img
            src="img/main/line-5.svg"
            alt=""
            :class="{ 'anim-glow': animations.anim4 === true }"
            style="animation-delay: 0.6s"
          />
        </div>
      </div>
      <div class="main-page-4__bg_3">
        <img class="first-bg-1" src="img/main/galaxy-3.png" alt="" /><img
          class="first-bg-2"
          src="img/main/galaxy-3.png"
          alt=""
        />
      </div>
    </section>
    <section class="main-page-5">
      <div class="container-main">
        <div class="main-page-5__heading vis_on_scroll" ref="heading5">
          <span v-html="t('welcome.our_partners')"></span>
        </div>
        <div class="main-page-5__items">
          <div
            class="main-page-5__item"
            :class="{ 'anim-fade': animations.anim5 === true }"
          >
            <img src="img/payments/item-1.png" alt="" />
          </div>
          <div
            class="main-page-5__item"
            :class="{ 'anim-fade': animations.anim5 === true }"
            style="animation-delay: 0.2s"
          >
            <img src="img/payments/item-2.png" alt="" />
          </div>
          <div
            class="main-page-5__item"
            :class="{ 'anim-fade': animations.anim5 === true }"
            style="animation-delay: 0.4s"
          >
            <img src="img/payments/item-3.png" alt="" />
          </div>
          <div
            class="main-page-5__item"
            :class="{ 'anim-fade': animations.anim5 === true }"
            style="animation-delay: 0.6s"
          >
            <img src="img/payments/item-4.png" alt="" />
          </div>
          <div
            class="main-page-5__item"
            :class="{ 'anim-fade': animations.anim5 === true }"
            style="animation-delay: 0.8s"
          >
            <img src="img/payments/item-5.png" alt="" />
          </div>
          <div
            class="main-page-5__item"
            :class="{ 'anim-fade': animations.anim5 === true }"
            style="animation-delay: 1s"
          >
            <img src="img/payments/item-6.png" alt="" />
          </div>
          <div
            class="main-page-5__item"
            :class="{ 'anim-fade': animations.anim5 === true }"
            style="animation-delay: 1.2s"
          >
            <img src="img/payments/item-7.png" alt="" />
          </div>
          <div
            class="main-page-5__item"
            :class="{ 'anim-fade': animations.anim5 === true }"
            style="animation-delay: 1.4s"
          >
            <img src="img/payments/item-8.png" alt="" />
          </div>
        </div>
        <div
          class="main-page-5__text_1 vis_on_scroll"
          ref="heading6"
          @click.prevent="redirect"
        >
          <span v-html="t('welcome.toRegister')"></span>
        </div>
        <div
          class="main-page-5__text_2"
          :class="{ 'anim-fade': animations.anim6 === true }"
        >
          <span>And get the opportunity of Private Round</span>
        </div>
        <button
          class="main-page-5__reg_btn"
          :class="{ 'anim-fade': animations.anim6 === true }"
          @click.prevent="redirect"
        >
          <span v-html="t('welcome.register')"></span>
          <div class="main-page-5__gradient"></div>
        </button>
      </div>
    </section>
    <div class="contacts-main">
      <div class="container-main">
        <div class="contacts-main__left_side">
          <div
            class="contacts-main__left_side_text_1 vis_on_scroll"
            ref="heading7"
          >
            <span v-html="t('welcome.make_first_steps')"></span>
          </div>
          <div
            class="contacts-main__left_side_text_2 contacts-main-text-1"
            :class="{ 'anim-fade': animations.anim7 === true }"
          >
            <span v-html="t('welcome.reg_and_get_case')"></span>
          </div>
          <button
            class="contacts-main__left_side_btn contacts-main-text-1"
            :class="{ 'anim-fade': animations.anim7 === true }"
            style="animation-delay: 0.2s"
            @click.prevent="redirect"
          >
            <span v-html="t('welcome.go_register')"></span>
            <div class="contacts-main__gradient"></div>
          </button>
        </div>
        <div class="contacts-main__right_side" ref="heading8">
          <!-- <div
            class="contacts-main__right_side_text_1 vis_on_scroll"
            ref="heading8"
          >
            <span
              >Tartu maakond, Tartu linn, Tartu linn,<br />Ranna tee 1b-3,
              51008</span
            >
          </div> -->
          <a
            class="contacts-main__right_side_text_2 contacts-main-text-2 anim-fade"
            :class="{ 'anim-fade': animations.anim8 === true }"
            href="mailto:contact@tokenza.io"
            ><span>contact@tokenza.io</span></a
          >
          <div class="contacts-main__right_side_soc">
            <a
              class="contacts-main__right_side_soc_item contacts-main-text-2 anim-fade"
              :class="{ 'anim-fade': animations.anim8 === true }"
              style="animation-delay: 0.2s"
              href="https://instagram.com/tokenza_io"
              ><img src="img/soc-1.svg" alt="" /><span>Instagram</span></a
            ><a
              class="contacts-main__right_side_soc_item contacts-main-text-2 anim-fade"
              :class="{ 'anim-fade': animations.anim8 === true }"
              style="animation-delay: 0.4s"
              href="https://t.me/tokenza_io"
              ><img src="img/soc-2.svg" alt="" /><span>Telegram</span></a
            ><a
              class="contacts-main__right_side_soc_item contacts-main-text-2 anim-fade"
              :class="{ 'anim-fade': animations.anim8 === true }"
              style="animation-delay: 0.6s"
              href="https://www.youtube.com/channel/UCBJ-ryUpMX93aZvjOZuLMPA"
              ><img src="img/soc-3.svg" alt="" /><span>YouTube</span></a
            >
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });

    return { t };
  },

  data() {
    return {
      animations: {},
      elements: {},
      isMobileScreen: true,
    };
  },

  methods: {
    redirect() {
      let ref = '';

      if (localStorage.getItem('referral') !== null) {
        ref = localStorage.getItem('referral') !== null ? '&ref='+localStorage.getItem('referral') : '';
      } else {
        ref = this.$route.query.ref !== undefined ? '&ref='+this.$route.query.ref : '';
      }

      const url = "https://tokenza.io/#/?login"
      // const url = "https://demo.promo/pa/outsource/tokenza/#/?login"

      const resultLink = url+ref;
      window.location =  resultLink
    },

    handleScroll() {
      Object.values(this.elements).forEach((element) => {
        const t = window.innerHeight - window.innerHeight / 6;
        const rect = element.getBoundingClientRect();

        if (!element.classList.contains("visible") && t > rect.top) {
          element.classList.add("visible");
        }
      });
    },

    animateElements(elementKeys) {
      elementKeys.forEach((elementKey) => {
        if (this.animations[elementKey] === false)
          this.animations[elementKey] = true;
      });
    },

    animateAfterAnimationEnd(eventElement, animateElements) {
      eventElement.addEventListener("animationend", () => {
        this.animateElements(animateElements); // array
      });
    },

    afterHeadingAnim() {
      Object.keys(this.elements).forEach((key, index) => {
        const element = this.$refs[`heading${index + 1}`];
        if (element === undefined) return;

        this.animateAfterAnimationEnd(element, [`anim${index + 1}`]);
      });
    },

    elementsInit() {
      for (let i = 1; i <= 11; i++) {
        this.elements[`heading${i}`] = this.$refs[`heading${i}`];
        this.animations[`anim${i}`] = false;
      }
    },

    updateScreenStyles() {
      this.$store.dispatch("updateMobileScreen", this.isMobileScreen);
      localStorage.setItem("mobileScreen", this.isMobileScreen);
    },

    checkLoginBuyRoute() {
      if (this.$route.query.login === null) {
        this.$emit("openPopup", { name: "PopupAuth", register: true });
      }
    },
  },

  created() {
    this.checkLoginBuyRoute();

    window.addEventListener("scroll", this.handleScroll);
  },

  mounted() {
    if (this.$route.query.ref !== undefined) {
      localStorage.setItem('referral', this.$route.query.ref)
    }

    this.elementsInit();
    this.afterHeadingAnim();
    this.$emit("langingPage", false);
    this.updateScreenStyles();
    this.$emit('pageUpdate', true)
  },

  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
    this.$emit('pageUpdate', false)
  },
};
</script>

<style lang="scss" scoped>
.airdrop-page {
  width: 100%;
}

.mobileScreen {
  @media (max-width: 1024px) {
    .main-page-3__bg_2 {
      top: unset;
      bottom: 12em;
    }
    .main-page-3__phone_2 {
      top: unset;
      bottom: -41em;
    }
    .main-page-3__line_3 {
      top: unset;
      bottom: -45em;
    }
    .main-page-3__line_4 {
      top: unset;
      bottom: -36em;
    }

    .main-page-4__line_5 {
      top: unset;
      bottom: -41em;
    }
    .main-page-4__coin_5 {
      top: unset;
      bottom: -47em;
    }
    .main-page-4__coin_4 {
      top: unset;
      bottom: -43em;
    }
  }
}
</style>
